import React from 'react';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
export function App() {
  return <PrivacyPolicy data-id="element-0" />;
}